import {
  collection,
  doc,
  getDocs,
  addDoc,
  updateDoc,
  query,
  orderBy,
  serverTimestamp,
  where,
} from 'firebase/firestore';
import { db } from './firebase';
import { getAuth } from 'firebase/auth';
import type { Visitor, VisitorFormData } from '../types/visitor';

const visitorsCollection = collection(db, 'visitors');

const mapVisitor = (snapshot: any): Visitor => {
  const data = snapshot.data();
  return {
    ...data,
    id: snapshot.id,
    createdAt: data.createdAt?.toDate?.() || new Date(),
    updatedAt: data.updatedAt?.toDate?.() || new Date(),
  } as Visitor;
};

export const visitorService = {
  async getAllVisitors(): Promise<Visitor[]> {
    const snapshot = await getDocs(query(visitorsCollection, orderBy('visitDate', 'desc')));
    return snapshot.docs.map(mapVisitor);
  },

  async addVisitor(formData: VisitorFormData): Promise<string> {
    const auth = getAuth();
    if (!auth.currentUser) throw new Error('로그인이 필요합니다.');
    const ref = await addDoc(visitorsCollection, {
      ...formData,
      source: 'manual',
      status: 'active',
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return ref.id;
  },

  async updateVisitor(id: string, updates: Partial<VisitorFormData>): Promise<void> {
    await updateDoc(doc(visitorsCollection, id), {
      ...updates,
      updatedAt: serverTimestamp(),
    });
  },

  async archiveVisitor(id: string): Promise<void> {
    await updateDoc(doc(visitorsCollection, id), {
      status: 'archived',
      archivedAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  },

  async findBySourceRow(sourceRowId: string): Promise<Visitor | null> {
    const snapshot = await getDocs(query(visitorsCollection, where('sourceRowId', '==', sourceRowId)));
    return snapshot.empty ? null : mapVisitor(snapshot.docs[0]);
  },
};
